import { BaseElementWithoutShadowDOM } from '@theme/base-element'
import ariaLiveRegionContext from '@theme/context-aria-live-region'
import { ContextConsumer, html, nothing } from '@theme/vendor-lit'

export class LiveRegion extends BaseElementWithoutShadowDOM {
  constructor(...args) {
    super(...args)
    new ContextConsumer(this, {
      context: ariaLiveRegionContext,
      subscribe: true,
      callback: (value) => {
        this.ariaLiveRegion = value
      },
    })
  }

  get politeness() {
    return this.ariaLiveRegion?.politeness || 'assertive'
  }

  render() {
    if (!this.ariaLiveRegion) {
      return html`${nothing}`
    }

    return html`
      <div class="sr-only" aria-live=${this.politeness} role="status">
        ${
          this.ariaLiveRegion.title
            ? html`<h2>${this.ariaLiveRegion.title}</h2>`
            : nothing
        }
        ${this.ariaLiveRegion.message ?? nothing}
      </div>
    `
  }
}

customElements.define('aria-live-region', LiveRegion)
